"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    cardBanner: {
        position: 'absolute',
        alignSelf: 'flex-end',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        right: 0,
        height: 31,
        paddingTop: theme.spacing(),
        borderRadius: '6px 0px 0px 0px',
        boxShadow: '-1px -1px 5px 0px rgba(0,0,0,0.75)',
        bottom: 0
    },
    cardBannerActive: {
        backgroundColor: theme.palette.error.main
    },
    cardBannerGrayedOut: {
        backgroundColor: theme.palette.grey.A100
    },
    cardBannerWhiteHighlight: {
        backgroundColor: theme.palette.common.white
    },
    cardBannerContentActive: {
        color: '#FFFFFF'
    },
    cardBannerContentGrayedOut: {
        color: theme.palette.grey[900]
    },
    cardBannerContentWhiteHighlight: {
        color: theme.palette.error.main
    }
});
exports.default = styles;
//# sourceMappingURL=CardBannerStyles.js.map